import { rootMargin } from '@helpers/animate';
import { formatDate } from '@helpers/date';
import { Icon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import { useInView } from '@hooks/useInView';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import { BlogCardStyles } from '@stories/Components/Cards/BlogCard/BlogCard.styles';
import CategoryTags from '@stories/Components/Misc/CategoryTags/CategoryTags';
import React from 'react';
import { FeaturedBannerStyles as S } from './FeaturedBanner.styles';
const FeaturedBanner = ({ title, intro, card, variant = 'white', pageContext, }) => {
    const srcs = getSrcs(card.image, 1558, 344, 5, 1558 / 439);
    const sizes = `${until(Device.Tablet)} 95vw, 1558px`;
    const [containerRef, inView] = useInView({ rootMargin }, false, pageContext?.isEditMode);
    return (React.createElement(S.MotionWrapper, { "data-in-view": inView },
        React.createElement(S.Container, { ref: containerRef, variant: variant },
            (title || intro) && (React.createElement(S.TopSection, null,
                title && React.createElement(S.Title, null, title),
                intro && React.createElement(S.Intro, null, intro))),
            React.createElement(S.BigBlogCard, { href: card.cta.url, target: card.cta.target },
                React.createElement(S.CardImage, null,
                    React.createElement("img", { src: srcs.src, srcSet: srcs.srcSet, sizes: sizes, loading: "eager", alt: card.image?.altText, role: !card.image?.altText ? 'presentation' : undefined })),
                React.createElement(S.CardContent, null,
                    card.tags.length > 0 && (React.createElement(BlogCardStyles.TagsWrapper, null,
                        React.createElement(CategoryTags, { items: card.tags }))),
                    React.createElement(BlogCardStyles.DateEstimatedReadingTime, null,
                        formatDate(card.date, 'do MMMM yyyy'),
                        " | ",
                        card.estimatedReadTime),
                    React.createElement(BlogCardStyles.Title, null, card.articleName),
                    card.description && React.createElement(BlogCardStyles.Intro, { dangerouslySetInnerHTML: { __html: card.description } }),
                    React.createElement(BlogCardStyles.ReadMore, null,
                        React.createElement(FakeButton, { buttonType: "text-white", icon: Icon.None }, card.cta.text)))))));
};
export default withMotionMax(FeaturedBanner);
